import { Component, input, signal, inject, model, computed, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { NotificationService } from '@shared/services';
import { UserStore } from '@signal-store/index';
import { AwaitingApprovalService } from './awaiting-approval.service';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { AddCommentApprovalModel, DoApprovalModel } from './awaiting-approval.model';
import { DocumentInfoModel } from '@module-instance/dynamic-module/document-details/common';

@Component({
  selector: 'cipo-awaiting-approval',
  imports: [MatIconModule, FroalaComponent, TranslateModule, FlexLayoutModule, MatButtonModule],
  templateUrl: './awaiting-approval.component.html',
})
export class AwaitingApprovalComponent {
  userStore = inject(UserStore);
  translate = inject(TranslateService);
  notification = inject(NotificationService);
  awaitingApprovalService = inject(AwaitingApprovalService);

  entityInstanceInfo = input<DocumentInfoModel>();
  disabled = model<boolean>();
  reload = output<void>();

  approvalComment = signal<string>(null);
  contractId = computed(() => this.userStore.contract()?.id);

  approveRejectDocument(approved: boolean) {
    this.disabled.set(true);

    const entityInstanceInfo = this.entityInstanceInfo();
    const body: DoApprovalModel = {
      id: entityInstanceInfo.approvalId,
      approved,
      comment: this.approvalComment(),
      workflowGroupId: entityInstanceInfo.workflowGroupId,
      documentNumber: entityInstanceInfo.documentNumberId,
      documentNoMinor: entityInstanceInfo.documentNoMinor,
    };

    this.awaitingApprovalService.doApproval(body, this.contractId()).subscribe({
      next: () => {
        this.disabled.set(false);
        this.reload.emit();
      },
      error: () => this.disabled.set(false),
    });
  }

  commentDocument() {
    const approvalComment = this.approvalComment();
    if ((approvalComment ?? '').trim() === '') {
      this.notification.error('awaitingApproval.addComment');
    } else {
      this.disabled.set(true);

      const body: AddCommentApprovalModel = {
        entityInstanceId: this.entityInstanceInfo().entityInstanceId,
        comment: this.approvalComment(),
      };
      this.awaitingApprovalService.addApprovalComment(body, this.contractId()).subscribe({
        next: () => {
          this.disabled.set(false);
          this.reload.emit();
        },
        error: () => {
          this.disabled.set(false);
        },
      });
    }
  }

  cancelApproval() {
    this.disabled.set(true);

    this.awaitingApprovalService.cancelApprovel(this.entityInstanceInfo().approvalId, this.contractId()).subscribe({
      next: () => {
        this.disabled.set(false);
        this.reload.emit();
      },
      error: () => this.disabled.set(false),
    });
  }
}
